/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Nav_SignalsInputs */

const en_landing_preview_nav_signals = /** @type {(inputs: Landing_Preview_Nav_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signals`)
};

/**
* | output |
* | --- |
* | "Signals" |
*
* @param {Landing_Preview_Nav_SignalsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_nav_signals = /** @type {((inputs?: Landing_Preview_Nav_SignalsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Nav_SignalsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_nav_signals(inputs)
});